import {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
  useRef,
} from 'react'
import { IGestor, IToken } from 'interfaces'
import io from 'socket.io-client'
import { SOCKET } from '../configs/configs.js'

interface IUserContextType {
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
  extended: boolean
  setExtended: Dispatch<SetStateAction<boolean>>
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
  showCarousel: boolean
  setShowCarousel: Dispatch<SetStateAction<boolean>>
  kanbanData: any
  setKanbanData: any
  searchParam: string
  setSearchParam: Dispatch<SetStateAction<string>>
  showModalNewClient: boolean
  setShowModalNewClient: Dispatch<SetStateAction<boolean>>
  preview?: string
  preview64?: string
  setPreview: Dispatch<SetStateAction<string>>
  setPreview64: Dispatch<SetStateAction<string>>
  gestor?: IGestor
  setGestor?: any
  allowNextPage: boolean
  setAllowNextPage: Dispatch<SetStateAction<boolean>>
  newToken?: IToken
  setNewToken?: any
  selectedCardId?: any
  setSelectedCardId?: any
  toggleOption?: string
  setToggleOption?: any
  radioBtnValue: any
  setRadioBtnValue: any
  checkbox: boolean
  setCheckbox: any
  clientOption: string
  setClientOption: any
  data: any
  setData: any
  formData: any
  retroData: any
  setRetroData: any
  // newEnterprise: any
  // setNewEnterprise: any
  resumo: any
  setResumo: any
  requestFn: any
  selectedId: any
  feedback: any
  toggleCap: string
  setToggleCap: Dispatch<SetStateAction<string>>
  page: number
  setPage: Dispatch<SetStateAction<number>>
  resumoDepo: any
  setResumoDepo: any
  // socket: any
  // enterprise: IEnterprise
}

export const UserContext = createContext<IUserContextType>(null!)

export function UserProvider({ children }: { children: React.ReactNode }) {
  // TITULO DO FEEDBACK
  const feedback = useRef({ title: 'default', error: false })

  const [loading, setLoading] = useState(false)

  // MENU
  const [extended, setExtended] = useState(true)

  // MODAL Cliente
  const [showModal, setShowModal] = useState(false)
  const [allowNextPage, setAllowNextPage] = useState(true)

  // CAROUSEL
  const [showCarousel, setShowCarousel] = useState<boolean>(false)

  // Kanban
  const [kanbanData, setKanbanData] = useState([])
  const [searchParam, setSearchParam] = useState('')
  const [selectedCardId, setSelectedCardId] = useState('')

  // MODAL Cliente
  const [showModalNewClient, setShowModalNewClient] = useState(false)

  // PAGINA DO MODAL
  const [page, setPage] = useState<number>(0)

  // imagens
  const [preview, setPreview] = useState('')
  const [preview64, setPreview64] = useState('')

  // register gestor
  const [gestor, setGestor] = useState<IGestor>({
    name: '',
    document: '',
    email: '',
    cellphone: '',
    level: [0, 0, 0, 0, 0, 0, 0, 0],
    profilePic: '',
  })

  // DADOS PARA TRANSFERENCIA (modal financeiro)
  const [resumo, setResumo] = useState({})

  // DADOS PARA DEPOSITO (modal financeiro)
  const [resumoDepo, setResumoDepo] = useState({})

  // const socket = io(SOCKET.URL)

  // DEFAULT ENTERPRISE
  // const enterprise = {
  //   // INFORMAÇÕES DO EMPREENDIMENTO
  //   name: '', // Nome completo - Teste de empreendimento 1/2023
  //   shortName: '', // Nome - resumido Empreendimento
  //   document: '', // CNPJ da SPE - 44.715.006/0001-10
  //   email: '', // Email do empreendimento - tst1_enterprise@gmail.com
  //   cellphone: '', // Telefone do empreendimento - (41) 98775-5223
  //   tick: '', // Sigla - TST1
  //   amount: null, // Número de unidades - 100
  //   value: null, // Valor da unidade - 1000000
  //   quotaValue: null, // Valor da cota - 1000
  //   contractList: [], // Lista de contratos - ['Contrato SCP', file]
  //   documentList: [], // Lista de documentos - ['Alvará', file]
  //   activateAt: '', // Data de ativação do Empreendimento - 20/04/2024
  //   readyAt: '', // Data de liberação - 20/04/2024
  //   enterperiseID: '', // ID do empreendimento base
  //   tokenID: '', ID da captacao base

  //   // ENDERECO
  //   address: {
  //     postalCode: '', // 32450-000
  //     address: '', // R. Das Abóboras
  //     number: '', // 123
  //     complement: '', // Conjunto hab.
  //     province: '', // Américas
  //     state: '', // MG
  //     city: '', // Sarzedo
  //   },

  //   // LAYOUT
  //   style: {
  //     iconList: [],
  //     color: ['', ''], // Primária, secundária, terciária...
  //     image: [], // Imagem do header, em file
  //     oppacity: 0.5, // Opacidade da película do header
  //   },
  // }

  // CRIAR NOVO EMPREENDIMENTO
  // const [newEnterprise, setNewEnterprise] = useState<IEnterprise>(enterprise)

  // DEFAULT CAPTACAO
  // INFORMAÇÕES DO PRODUTO
  // name: '', // Nome completo
  // fonetic: '', // Nome resumido
  // tick: '', // Tick
  // type: '', // Tipo de captação [FIAT, COIN, RENTAL, ...]
  // guaranteeList: [], // Lista de garantias

  // // INFORMAÇÕES DA CAPTAÇÃO
  // price: '', // Inicial price
  // maxSupply: '', // Total supply (total de cotas)
  // minInvest: '', // Valor mínimo para entrada
  // icoDays: '', // In days - Período de lançamento

  // // RENTABILIDADE
  // deadline: '', // Prazo do contrato em meses
  // recurrencyType: '', // Pagamento dos juros
  // principalLiquidityType: '', // Data de saque do principal
  // paymentType: '', // Tipo de pagamento dos juros [PRE, POS, HYBRID]
  // indiceId: undefined, // Id do indexador (apenas para pós e híbrido)
  // profitability: '', // Annual profitability
  // IRType: '', // DEFAULT - desconto na fonte
  // cotizationIn: '', // In days - Cotização de entrada
  // cotizationOut: '', // In days - Cotização de saída
  // isCotizationProfitable: '', // boolean - Cotização de saída rentabilizada
  // releaseAt: '' // data de lancamento

  // // LAYOUT
  // style: {
  //     iconList: [],
  //     color: ['', ''], // Primária, secundária, terciária...
  //     image: [], // Imagem do header, em file
  //     oppacity: 0.5, // Opacidade da película do header
  //   },

  // // DETALHES DA CAPTAÇÃO
  // details: [],

  // COMISSAO
  //   comissionPolicy: {
  //     goal: [0, -- Meta de venda em R$ da equipe 0, -- Porcentagem da equipe]
  //     distribussion: {
  //       title: 'Comissão de vendas',
  //        target: '',
  //       value: [
  //         {
  //           title: 'Diretor',
  //           values: [
  //             [0,   --  de R$ 1.000 - Number
  //              0,   --  ate R$ 10.000 - Number
  //              0],  -- 5% - Number (0 a 1)
  //             [0,  -- de R$ 10.000
  //              0,  -- ate R$ 50.000
  //              0],  -- 10%
  //             [0,   --  de R$ 50.000
  //              0,   --  ate R$ 100.000
  //              0],   --  15%
  //           ],
  //         },
  //         {
  //           title: 'Gestor',
  //            target: '',
  //           values: [
  //             [0, 0, 0],
  //             [0, 0, 0],
  //             [0, 0, 0],
  //           ],
  //         },
  //         {
  //           title: 'Especialista',
  //            target: '',
  //           values: [
  //             [0, 0, 0],
  //             [0, 0, 0],
  //             [0, 0, 0],
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       title: 'Comissão de carteira',
  //       value: [
  //         {
  //           title: 'Gestão Diretor',
  //            target: '',
  //           values: [
  //             [0, 0, 0],
  //             [0, 0, 0],
  //             [0, 0, 0],
  //           ],
  //         },
  //         {
  //           title: 'Gestão Gestor',
  //            target: '',
  //           values: [
  //             [0, 0, 0],
  //             [0, 0, 0],
  //             [0, 0, 0],
  //           ],
  //         },
  //         {
  //           title: 'Gestão Especialista',
  //           target: '',
  //           values: [
  //             [0, 0, 0],
  //             [0, 0, 0],
  //             [0, 0, 0],
  //           ],
  //         },
  //       ],
  //     },
  //   ]
  // }
  // // MISCELÂNEA
  // blockchain: '', // Blockchain onde a token será criada
  // hasCETIP: false, // Possui selo?
  // hasCupom: false, // Possui cupom?

  // PERSONALIZADA
  // ruleList: [ {REQUIRED_ACCOUNT: [ids ]}] /para investimento em grupo ou 1 pessoa

  const [newToken, setNewToken] = useState<IToken>({
    // INFORMAÇÕES DO PRODUTO
    name: '', // Nome completo
    fonetic: '', // Nome resumido
    tick: '', // Tick
    accountList: [], // (Aberta se for vazio) Lista de clientes para investimentos personalizados
    type: '', // Tipo de captação [FIAT, COIN, RENTAL, ...]
    guaranteeList: [], // Lista de garantias

    // INFORMAÇÕES DA CAPTAÇÃO
    price: '', // Inicial price
    maxSupply: '', // Total supply (total de cotas)
    minInvest: '', // Valor mínimo para entrada
    icoDays: '', // In days - Período de lançamento

    // RENTABILIDADE
    deadline: '', // Prazo do contrato em meses
    recurrencyType: '', // Pagamento dos juros
    principalLiquidityType: '', // Data de saque do principal
    paymentType: '', // Tipo de pagamento dos juros [PRE, POS, HYBRID]
    indiceId: undefined, // Id do indexador (apenas para pós e híbrido)
    profitability: '', // Annual profitability
    IRType: '', // DEFAULT - desconto na fonte
    cotizationIn: '', // In days - Cotização de entrada
    cotizationOut: '', // In days - Cotização de saída

    // LAYOUT
    style: {
      iconList: [],
      color: [], // Primária, secundária, terciária...
      image: {
        base64: '', // Imagem do header em base64
        oppacity: '', // Opacidade da película do header
      },
    },

    // DETALHES DA CAPTAÇÃO
    details: [],
    contractList: [],

    // MISCELÂNEA
    blockchain: '', // Blockchain onde a token será criada
    hasCETIP: false, // Possui selo?
    hasCupom: false, // Possui cupom?
  })

  // NOVA CONTA
  const [newAccount, setNewAccount] = useState({ document: '' })

  // Toggle
  const [toggleOption, setToggleOption] = useState<string>('')

  // Toggle do form de captacao obs: nao esta aceitando o useState passado como prop
  const [toggleCap, setToggleCap] = useState<any>('')

  // Radio btn
  const [radioBtnValue, setRadioBtnValue] = useState('')

  // checkbox
  const [checkbox, setCheckbox] = useState(false)

  // clienteOption
  const [clientOption, setClientOption] = useState<string>('')

  // data
  const [data, setData] = useState()
  const formData = useRef<FormData>(new FormData())
  const [retroData, setRetroData] = useState()

  // request fn
  const requestFn = useRef(() => null)
  const selectedId = useRef(null)

  const value = {
    resumo,
    setResumo,
    retroData,
    setRetroData,
    loading,
    setLoading,
    extended,
    setExtended,
    showModal,
    setShowModal,
    showCarousel,
    setShowCarousel,
    searchParam,
    setSearchParam,
    showModalNewClient,
    setShowModalNewClient,
    kanbanData,
    setKanbanData,
    preview,
    setPreview,
    preview64,
    setPreview64,
    gestor,
    setGestor,
    allowNextPage,
    setAllowNextPage,
    newToken,
    setNewToken,
    selectedCardId,
    setSelectedCardId,
    toggleOption,
    setToggleOption,
    radioBtnValue,
    setRadioBtnValue,
    checkbox,
    setCheckbox,
    clientOption,
    setClientOption,
    data,
    setData,
    formData,
    resumoDepo,
    setResumoDepo,
    // newEnterprise,
    // setNewEnterprise,
    requestFn,
    selectedId,
    feedback,
    toggleCap,
    setToggleCap,
    page,
    setPage,
    // socket,
    // enterprise,
  }

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}
